import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-40e959e0")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", {
    id: "top-toolbar-container",
    class: "p-d-flex",
    style: _ctx.toolbarDescriptor.style.topToolbarContainer
  }, [
    _createVNode("span", {
      id: "topaxis",
      ref: "filterPanelContainer",
      class: "kn-flex p-d-flex",
      style: _ctx.toolbarDescriptor.style.topAxis,
      onDrop: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onDrop($event))),
      onDragover: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
      onDragenter: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.displayDropzone && _ctx.displayDropzone(...args))),
      onDragleave: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.hideDropzone && _ctx.hideDropzone(...args)))
    }, [
      _createVNode(_component_Button, {
        icon: "fa-solid fa-repeat",
        class: "p-button-text p-button-rounded p-button-plain",
        style: _ctx.toolbarDescriptor.style.whiteColor,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('swapAxis')))
      }, null, 8, ["style"]),
      (_ctx.showScroll)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            icon: "fas fa-arrow-circle-left",
            class: "p-button-text p-button-rounded p-button-plain p-ml-1 p-as-center",
            style: _ctx.toolbarDescriptor.style.whiteColor,
            onClick: _ctx.scrollLeft
          }, null, 8, ["style", "onClick"]))
        : _createCommentVNode("", true),
      _createVNode("div", {
        ref: "filterItemsContainer",
        class: "p-d-flex p-ai-center kn-flex",
        style: _ctx.toolbarDescriptor.style.scroll
      }, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (column, index) => {
          return (_openBlock(), _createBlock("div", {
            key: index,
            class: "p-d-flex"
          }, [
            _createVNode("div", {
              id: 'top-' + column.name,
              ref: 'top-' + column.name,
              style: _ctx.toolbarDescriptor.style.topAxisCard,
              draggable: "true",
              onDragstart: ($event: any) => (_ctx.onDragStart($event, column, 'top-' + column.name)),
              onDragend: ($event: any) => (_ctx.removeDragClass('top-' + column.name))
            }, [
              (column.hierarchies.length > 1)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    icon: "fas fa-sitemap",
                    class: "p-button-text p-button-rounded p-button-plain",
                    style: _ctx.toolbarDescriptor.style.whiteColor,
                    onClick: ($event: any) => (_ctx.$emit('showMultiHierarchy', column))
                  }, null, 8, ["style", "onClick"]))
                : _createCommentVNode("", true),
              _withDirectives(_createVNode("span", {
                class: ["kn-flex kn-truncated", { 'p-ml-2': column.hierarchies.length == 1 }]
              }, [
                _createTextVNode(_toDisplayString(_ctx.cutName(column.caption, 0, column.hierarchies.length > 1)), 1)
              ], 2), [
                [
                  _directive_tooltip,
                  column.caption,
                  void 0,
                  { top: true }
                ]
              ]),
              _createVNode("div", {
                id: "whitespace",
                style: _ctx.toolbarDescriptor.style.whitespace
              }, null, 4),
              _createVNode(_component_Button, {
                icon: "fas fa-filter",
                class: "p-button-text p-button-rounded p-button-plain",
                style: _ctx.toolbarDescriptor.style.whiteColor,
                onClick: ($event: any) => (_ctx.openFilterDialog(column))
              }, null, 8, ["style", "onClick"])
            ], 44, ["id", "onDragstart", "onDragend"]),
            (column.positionInAxis < _ctx.columns.length - 1)
              ? (_openBlock(), _createBlock("i", {
                  key: 0,
                  class: "fas fa-arrows-alt-h p-as-center p-mx-2",
                  style: {"cursor":"pointer"},
                  onClick: ($event: any) => (_ctx.$emit('switchPosition', column))
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _createVNode("div", {
          ref: "axisDropzone",
          class: "kn-flex kn-truncated p-mx-1",
          style: _ctx.toolbarDescriptor.style.topAxisDropzone
        }, _toDisplayString(_ctx.$t('documentExecution.olap.filterToolbar.drop')), 5)
      ], 4),
      (_ctx.showScroll)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            icon: "fas fa-arrow-circle-right",
            class: "p-button-text p-button-rounded p-button-plain p-mr-1 p-as-center",
            style: _ctx.toolbarDescriptor.style.whiteColor,
            onClick: _ctx.scrollRight
          }, null, 8, ["style", "onClick"]))
        : _createCommentVNode("", true),
      _createVNode("div", {
        id: "whitespace",
        style: _ctx.toolbarDescriptor.style.whitespace
      }, null, 4),
      _createVNode(_component_Button, {
        icon: "fas fa-bars",
        class: "p-button-text p-button-rounded p-button-plain",
        style: _ctx.toolbarDescriptor.style.sidebarButton,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('openSidebar')))
      }, null, 8, ["style"])
    ], 36)
  ], 4))
})